/// <amd-module name="Wit/Common/QueryUtils/RoutingUtils" />
import { getTFSPageData } from "Tfs/Platform/Page";
import { newGuid } from "VSS/Core/Util/String";
import { IVssPageContext } from "VSS/Platform/Context";
import { IFPSData, onClickFPS } from "VSS/Platform/FPS";
import { routeUrl } from "VSS/Platform/Location";

export const queriesRoute = "ms.vss-work-web.new-queries-hub-route";
export const workItemFormRoute = "ms.vss-work-web.work-items-form-route";

export type RouteValues = { [key: string]: string };

export type UrlAndRouteValues = {
    url: string;
    routeValues: RouteValues;
};

export function getDeletedUrl(pageContext: IVssPageContext) {
    const projectName = getTFSPageData(pageContext)?.project?.name;
    const routeValues = {
        project: projectName || "",
        view: "deleted"
    };

    return routeUrl(pageContext, queriesRoute, routeValues);
}

export function getEditorUrl(pageContext: IVssPageContext, queryId?: string, parentId?: string, temporaryQueryId?: string, wiql?: string) {
    return getViewUrl(pageContext, "query-edit", queryId, parentId, temporaryQueryId, wiql).url;
}

export function getChartsUrl(pageContext: IVssPageContext, queryId?: string, parentId?: string, temporaryQueryId?: string, wiql?: string) {
    return getViewUrl(pageContext, "query-charts", queryId, parentId, temporaryQueryId, wiql).url;
}

export function getImportWorkItemsUrl(pageContext: IVssPageContext) {
    const projectName = getTFSPageData(pageContext)?.project?.name;
    const routeValues = {
        project: projectName || "",
        view: "query",
        importData: "csv"
    };

    return routeUrl(pageContext, queriesRoute, routeValues);
}

export function getQueryUrl(pageContext: IVssPageContext, queryId?: string, parentId?: string, temporaryQueryId?: string, wiql?: string) {
    return getViewUrl(pageContext, "query", queryId, parentId, temporaryQueryId, wiql).url;
}

export function getQueryFolderUrl(pageContext: IVssPageContext, folderPath?: string) {
    const projectName = getTFSPageData(pageContext)?.project?.name;
    const routeValues: { [key: string]: string } = {};
    routeValues["project"] = projectName || "";
    if (folderPath) {
        routeValues["view"] = "folder";
        routeValues["path"] = folderPath;
    } else {
        routeValues["view"] = "all";
    }
    return routeUrl(pageContext, queriesRoute, routeValues);
}

export function getWorkItemEditUrl(pageContext: IVssPageContext, workItemId: number, teamProject?: string): UrlAndRouteValues {
    const projectName = teamProject ?? getTFSPageData(pageContext)?.project?.name;
    const routeValues = {
        project: projectName || "",
        view: "edit",
        id: String(workItemId)
    };
    return { url: routeUrl(pageContext, workItemFormRoute, routeValues), routeValues };
}

export function getContributedTabUrl(
    pageContext: IVssPageContext,
    tabId: string,
    queryId?: string,
    parentId?: string,
    temporaryQueryId?: string,
    wiql?: string
) {
    return getViewUrl(pageContext, tabId, queryId, parentId, temporaryQueryId, wiql).url;
}

export function getViewUrl(
    pageContext: IVssPageContext,
    view: string,
    queryId: string | undefined,
    parentId: string | undefined,
    temporaryQueryId: string | undefined,
    wiql: string | undefined
): UrlAndRouteValues {
    const projectName = getTFSPageData(pageContext)?.project?.name;
    const routeValues: { [key: string]: string } = {};
    routeValues["project"] = projectName || "";
    routeValues["view"] = view;

    if (temporaryQueryId) {
        routeValues["tempQueryId"] = temporaryQueryId;
    } else if (wiql) {
        routeValues["wiql"] = wiql;
    } else if (queryId && queryId.length > 0) {
        routeValues["id"] = queryId;
    } else {
        routeValues["newQuery"] = true.toString();
        routeValues["parentId"] = parentId ?? newGuid();
    }

    return { url: routeUrl(pageContext, queriesRoute, routeValues), routeValues };
}

export function onClickQuerySaveFPS(
    pageContext: IVssPageContext,
    href: string,
    recordHistoryEntry: boolean,
    event?: React.SyntheticEvent<HTMLElement>,
    data: IFPSData = {}
): boolean | void {
    const fpsData = Object.assign(data, { isQuerySaveFPS: true });
    return onClickFPS(pageContext, href, recordHistoryEntry, event, fpsData);
}
